import { render, staticRenderFns } from "./ObservacoesTab.vue?vue&type=template&id=65c78cac"
import script from "./ObservacoesTab.vue?vue&type=script&lang=js"
export * from "./ObservacoesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports